import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../helpers"
import { Context, Transitions } from "../types"

export const undoTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "undo",
    onDone: {
      target: "#StudyPlan.edit_plan.go_back_to_previous",
      actions: [
        "expandRelatedSections",
        assign((_ctx, evt) => ({
          studyPlan: evt.data.plan
        }))
      ]
    },
    onError: {
      target: "#StudyPlan.edit_plan.go_back_to_previous",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("undo", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
